import { FirestoreService } from "../../../../api/firebase/firestoreService";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import { MedicalPaOrder } from "../../../../data-model/medicalPaOrdersModel";
import { ModalId } from "../../../../enums/modalId";
import {
  setMetaData,
  setOpenedModalId,
} from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";
import { logError } from "../../../../utils/customLogger";
import { getFilePathsForModal } from "../../external/allPaOrdersForExternal/utils/allPaOrdersForExternalHelper";

export const handleDocUploadScreenshotViewForMyPaOrders = async (
  id: string,
  dispatch: AppDispatch,
  authStatusOptions: AuthStatusOptionModel[],
) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.IMAGE_VIEWER_MODAL,
      metaData: { showLoader: true },
    }),
  );

  try {
    const document = (await FirestoreService.getDocument(
      `/medical_pa_orders/${id}`,
    )) as MedicalPaOrder;
    const filePaths = getFilePathsForModal(document);
    dispatch(
      setMetaData({
        filePaths: filePaths,
        showLoader: false,
      }),
    );
  } catch (error) {
    logError(error as Error);
    dispatch(
      setMetaData({
        filePaths: [],
        showLoader: false,
      }),
    );
  }
};
